import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Maestros_SectorService } from '../../services/maestros_sector.service';
import { Maestros_ConsultasService } from 'src/app/services/maestros_consultas.service';
import { Maestros_ConsultasTiposService } from 'src/app/services/maestros_consultastipos.service';
import { Maestro_ConsultasTipos } from 'src/app/models/generic/Maestro_ConsultasTipos';
import { Maestros_GruposMenuService } from '../../services/maestros_gruposmenu';
import { Maestro_Grupos_Menu, TodoItemFlatNode, TodoItemNode } from 'src/app/models/generic/Maestro_Grupos_Menu';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'menu-configuracion',
  templateUrl: './menu-configuracion.component.html',
  styleUrls: ['./menu-configuracion.component.scss']
})
export class MenuConfiguracionComponent implements OnInit{
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_GruposMenuService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  AbrirOpcionConfiguracion(opcionAbrir: string) {
    this.menuService.CambiarComponenteActivo(opcionAbrir);
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('MenuConfiguracionComponent');
  }
}

//(click)="AbrirOpcionConfiguracion('MaestrosProductosComponent')"

// Configurar reportes	MaestrosConsultasComponent-OK
// Configurar cargas archivos	MaestrosCargasArchivosComponent-OK
// Configurar carga API clientes asegurados	MaestrosCargaApiClientesAseguradosComponent-OK
// Registrar sector	MaestrosSectorComponent-OK
// Registrar roles dominio	MaestrosRolesDominioComponent-OK
// Registrar roles	MaestrosRolesComponent-OK
// Registrar aliados	MaestrosAliadosComponent-OK
// Registrar dashboard	MaestrosDashboardComponent-OK
// Registrar usuarios	MaestrosUsuariosComponent-OK
// Registrar grupos	MaestrosGruposComponent-OK
// Matriz acceso	MaestrosMatrizAccesoComponent-OK
// Registrar provincias	MaestrosProvinciasComponent-OK
// Configurar menús	MaestrosMenuComponent-OK
// Programas	MaestrosProductosComponent-OK